import { lazy } from 'react';
import { RemoteSvgSSR } from './RemoteSvgSSR';

/**
 * If running on the client, use RemoteSvgCSR, otherwise use RemoteSvgSSR
 */
export const RemoteSvg = typeof window !== 'undefined' 
  ? lazy(() => import('./RemoteSvgCSR')) 
  : RemoteSvgSSR;
